import {
  Directive, ElementRef, Input, OnInit, OnDestroy, Inject,
} from '@angular/core';
import Clipboard from 'clipboard';

@Directive({
  selector: '[utClipboard]',
  standalone: false,
})
export class ClipboardDirective implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('data-clipboard-text') clipboardText: string;
  private clipboard: Clipboard;

  constructor(
    private el: ElementRef,
    @Inject('AlertService') private AlertService: any,
  ) {}

  ngOnInit(): void {
    this.el.nativeElement.setAttribute('title', 'Copy');
    this.el.nativeElement.classList.add('clickable');

    this.clipboard = new Clipboard(this.el.nativeElement);

    this.clipboard.on('success', () => {
      this.AlertService.add('Copied!');
    });

    this.clipboard.on('error', () => {
      this.AlertService.add('Copy to clipboard is not supported in your browser', 'warning');
    });
  }

  ngOnDestroy(): void {
    if (this.clipboard) {
      this.clipboard.destroy();
    }
  }
}
